import React, { useEffect } from 'react';

const RedirectToPromoVideo = () => {
    useEffect(() => {
        window.location.href =
            'https://360.articulate.com/review/content/20ac3c13-34f5-4836-b4d5-35cbce495331/review';
    }, []);

    return <div>You are being redirected...</div>;
};

export default RedirectToPromoVideo;
